export const locale = {
  lang: "it",
  data: {
    MENU: {
      PRODUCTS: "Prodotti",
      CREATE_PRODUCT: "Crea prodotto",
      EDIT_PRODUCT: "Modifica prodotto",
      PRODUCT_DETAIL: "Dettaglio prodotto",
      CREATE_PRODUCT_COMMISSION: "Crea commessa di prodotto",
      EDIT_PRODUCT_COMMISSION: "Modifica commessa di prodotto",
      PRODUCTS_COSTS: "Costi prodotto",
    },
    ALERT: {
      SUCCESS_CREATE_PRODUCT: "Prodotto creato con successo",
      ERROR_CREATE_PRODUCT: "Errore nella creazione del prodotto",
      SUCCESS_EDIT_PRODUCT: "Prodotto modificato con successo",
      ERROR_EDIT_PRODUCT: "Errore nella modifica del prodotto",
      SUCCESS_DELETE_PRODUCT: "Prodotto eliminato con successo",
      ERROR_DELETE_PRODUCT: "Errore nella cancellazione del prodotto",
      ERROR_INSERT_COST: "Inserisci il costo del prodotto",
      REMOVED_EMPLOYEE_PRESENT_DATATABLE: "Hai rimosso un prodotto selezionato nella tabella, il sistema ha rimosso il prodotto dalla tabella.",
      NO_COMMISSIONS: "Non ci sono commesse da mostrare.",
      NO_DEALS: "Non ci sono offerte da mostrare.",
      SUCCESS_UPDATE_PRODUCT_COST: "Costo prodotto modificato con successo",
      ERROR_UPDATE_PRODUCT_COST: "Errore nella modifica del costo prodotto",
      ERROR_VIEW_FUTURE_COST: "Non puoi visualizzare i costi per i mesi futuri",
    },
    ERRORS: {
      INSERT_MONTHLY_COST: "Il campo costo mensile è obbligatorio.",
      INSERT_MONTHLY_AMOUNT: "Il campo importo mensile è obbligatorio.",
      PRODUCTS_REQUIRED: "Il campo prodotti è obbligatorio.",
      ERROR_QUANTITY: "Compila correttamente il campo quantità nella tabella.",
      ERROR_PRICE: "Compila correttamente il campo prezzo nella tabella.",
    },
    PLACEHOLDER: {
      SELECT_ONE_OR_MORE_PRODUCT: "Seleziona uno o più prodotti",
    },
    DETAIL_OFFER_PRODUCT: "Dettaglio offerta prodotto",
    TRANCHE_IMPORT_PRODUCT: "Importo tranche prodotto",
    PRODUCTS_DETAIL: "Dettaglio prodotti",
    OPEN_DETAIL_PRODUCT: "Apri dettaglio prodotti",
    CLOSE_DETAIL_PRODUCT: "Chiudi dettaglio prodotti",
  },
};
